// extracted by mini-css-extract-plugin
export default {"content":"Vr","img":"Wr","wrapper":"Xr","icons":"Yr","btn":"Zr","drawer_close_button":"as"};
    if(module.hot) {
      // 1713912563115
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  